<template>
  <v-dialog v-model="dialog" :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-row>
      <v-col cols="12">
        <v-card tile v-if="entry">
          <v-card-title>
            {{ entry.fileName }}
            <v-spacer></v-spacer>
            <v-btn icon class="text-right" @click="$emit('close-client-file-viewer-dialog')">
              <v-icon>{{ closeIcon }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="py-0 px-1 text-center">
            <v-row justify="center" align-self="center">
              <v-col cols="12" align-self="center">
                <!-- video -->
                <vue-plyr :key="`plyr-${entry.id}-${entry.userId}`" ref="player" :emit="['loadeddata', 'canplay']"
                          v-if="entry.fileType === ClientFileType.VIDEO" :options="videoOptions">
                  <video playsinline controls :style="{width: $vuetify.breakpoint.xsOnly ? '75vw' : 'auto'}">
                    <source :src="videoSource" type="video/mp4">
                  </video>
                </vue-plyr>

                <!-- logs -->
                <code v-if="logData" class="text-left"
                      :style="{width: $vuetify.breakpoint.xsOnly ? '75vw' : 'auto'}">{{logData.trim()}}</code>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import VuePlyr from 'vue-plyr'

import { ServerFile } from '@/models/serverRequests/ServerFile'
import { ClientFileType } from '@/enum'
import { mdiClose } from '@mdi/js'
import backend from '@/backend'
import { requestedLogFile, requestedVideoFile } from '@/utils/requests'

const defaultSeekTime = 0.1

const generateVideoControls = (options) => {
  const controls = []

  if (options.fetchFps) {
    controls.push('rewind')
  }

  controls.push('play')

  if (options.fetchFps) {
    controls.push('fast-forward')
  }

  return [...controls, ...[
    'progress',
    'current-time',
    'duration',
    'volume',
    'settings',
    'download',
    'fullscreen'
  ]]
}

export default {
  name: 'clientFileViewer',
  props: {
    dialog: Boolean,
    entry: ServerFile
  },
  components: {
    VuePlyr
  },
  data: () => ({
    closeIcon: mdiClose,
    logData: null,
    videoOptions: {
      controls: generateVideoControls({ fetchFps: true }),
      seekTime: defaultSeekTime,
      muted: true
    }
  }),
  computed: {
    videoSource () {
      return requestedVideoFile(this.entry)
    },
    logSource () {
      return requestedLogFile(this.entry)
    }
  },
  methods: {
    async getLogData () {
      const result = await backend._apiGet({ url: this.logSource })
      this.logData = result.data
    }
  },
  created () {
    this['ClientFileType'] = ClientFileType
  },
  watch: {
    async dialog (value) {
      if (value && this.entry.fileType === ClientFileType.LOG) {
        await this.getLogData()
      }
    }
  }
}
</script>

<style scoped>

</style>
